import styles from './FeaturesSection.module.css'

function TinyPitch() {
  const slots = [
    { top: '80%', left: '50%', empty: false },
    { top: '60%', left: '22%', empty: false },
    { top: '60%', left: '42%', empty: false },
    { top: '60%', left: '58%', empty: false },
    { top: '60%', left: '78%', empty: false },
    { top: '35%', left: '30%', empty: false },
    { top: '35%', left: '50%', empty: false },
    { top: '35%', left: '70%', empty: false },
    { top: '14%', left: '30%', empty: false },
    { top: '14%', left: '50%', empty: false },
    { top: '14%', left: '70%', empty: true },
  ]
  return (
    <div className={styles.tinyPitch}>
      {slots.map((s, i) => (
        <div
          key={i}
          className={`${styles.tpSlot} ${s.empty ? styles.tpSlotEmpty : ''}`}
          style={{ top: s.top, left: s.left }}
        />
      ))}
    </div>
  )
}

function LiveDemo() {
  const events = [
    { time: "87'", type: 'GOL · Maya', pts: '+16', live: true },
    { time: "84'", type: 'Asst · Kléber', pts: '+5', live: true },
    { time: "78'", type: 'CS · Alisson', pts: '+4', live: false },
    { time: "71'", type: 'Save · Alisson', pts: '+2', live: false },
  ]
  return (
    <div className={styles.demoLive}>
      {events.map((e, i) => (
        <div key={i} className={styles.demoLiveRow}>
          <span className={styles.demoLiveLeft}>
            <span className={`${styles.demoDot} ${e.live ? styles.demoDotLive : ''}`} />
            {e.time} · {e.type}
          </span>
          <span className={styles.demoPts}>{e.pts}</span>
        </div>
      ))}
    </div>
  )
}

function PrizeDemo() {
  return (
    <div className={styles.demoPrize}>
      <div>
        <div className={styles.demoPrizeLbl}>PRIZE POOL · LIGA</div>
        <div className={styles.demoPrizeSub}>240 jogadores · R$ 25</div>
      </div>
      <div className={styles.demoPrizeAmt}>R$ 4.8K</div>
    </div>
  )
}

const STEPS = [
  {
    num: '01',
    eyebrow: 'SETUP · 90 SEGUNDOS',
    title: 'Escala seu XI.',
    desc: 'Onze jogadores, qualquer formação — Copa de Seleções 2026. Capitão vale dobrado.',
    demo: <TinyPitch />,
  },
  {
    num: '02',
    eyebrow: 'JOGA · LANCE A LANCE',
    title: 'Pontos sobem\ncom a bola.',
    desc: 'O placar mexe enquanto o jogo rola. Gols, assistências, cartões, defesas — cada lance vira ponto no seu painel na hora, sem refresh.',
    demo: <LiveDemo />,
  },
  {
    num: '03',
    eyebrow: 'GANHA · PIX EM 48H',
    title: 'Vence a sua liga.',
    desc: 'Liga com amigos ou prize pool aberto, gratuita ou paga. Top 3 leva — pago em PIX.',
    demo: <PrizeDemo />,
  },
]

export function FeaturesSection() {
  return (
    <section className={styles.section} id="como-funciona">
      <div className={styles.sectionHead}>
        <div>
          <div className={styles.num}>02 / COMO FUNCIONA</div>
          <h2 className={styles.heading}>
            Três passos.<br />
            Zero <span className={styles.glow}>fricção</span>.
          </h2>
        </div>
        <div className={styles.headRight}>
          Não é um app de planilha disfarçado. É um relógio de matchday.
        </div>
      </div>

      <div className={styles.steps}>
        {STEPS.map((step) => (
          <div key={step.num} className={styles.step}>
            <div className={styles.stepNum}>{step.num}</div>
            <div className={styles.stepEyebrow}>{step.eyebrow}</div>
            <h3 className={styles.stepTitle}>
              {step.title.split('\n').map((line, i) => (
                <span key={i}>{line}{i < step.title.split('\n').length - 1 && <br />}</span>
              ))}
            </h3>
            <p className={styles.stepDesc}>{step.desc}</p>
            <div className={styles.stepDemo}>{step.demo}</div>
          </div>
        ))}
      </div>

      {/* ─── Formats subsection ──────────────────────────────────────────── */}
      <div className={styles.formats} id="formatos">
        <div className={styles.formatsHead}>
          <div className={styles.formatsEyebrow}>FORMATOS DE LIGA</div>
          <h3 className={styles.formatsTitle}>
            Três formas de jogar.{' '}
            <span className={styles.glow}>Uma é só nossa.</span>
          </h3>
          <p className={styles.formatsSub}>
            Quem cria a liga escolhe o formato. Quem entra, joga do seu jeito —
            do esquema de pontuação ao prize pool, tudo configurável.
          </p>
        </div>

        <div className={styles.formatsGrid}>
          <div className={styles.formatCard}>
            <div className={styles.formatTag}>PONTOS CORRIDOS</div>
            <h4 className={styles.formatName}>Liga tradicional</h4>
            <p className={styles.formatDesc}>
              Soma os pontos da rodada, sobe na tabela. Quem terminar a temporada
              em primeiro, leva. Igual a Premier League, só que sua.
            </p>
          </div>

          <div className={styles.formatCard}>
            <div className={styles.formatTag}>HEAD-TO-HEAD</div>
            <h4 className={styles.formatName}>Mata-mata semanal</h4>
            <p className={styles.formatDesc}>
              Cada rodada vira um confronto direto contra outro participante.
              Pontuou mais? <strong>+3 na tabela H2H</strong>. Drama todo fim de semana.
            </p>
          </div>

          <div className={`${styles.formatCard} ${styles.formatCardNew}`}>
            <div className={styles.formatTagNew}>✦ SOBREVIVENTE · EXCLUSIVO</div>
            <h4 className={styles.formatName}>Errou, tá fora.</h4>
            <p className={styles.formatDesc}>
              Cada rodada você escolhe <strong>um time</strong> pra apostar. Acertou,
              sobrevive. Empatou ou perdeu, eliminado. Picks ocultos até o apito —
              ninguém vê o seu até a janela fechar. Último que sobra é{' '}
              <strong>o sobrevivente</strong>.
            </p>
            <div className={styles.formatBadge}>
              Nenhum outro fantasy faz isso. A gente inventou.
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
